// extracted by mini-css-extract-plugin
module.exports = {"list":"index_list_1zI0V","itemLink":"index_itemLink_2zDZX","itemAction":"index_itemAction_p2Hxl","itemMeta":"index_itemMeta_tMPE9","item":"index_item_OnFt0"};